import type { RouteRecordRaw } from 'vue-router';

export default <RouteRecordRaw[]>[
  {
    path: 'how-to',
    redirect: '/support/how-to/general-videos',
    children: [
      {
        path: 'general-videos',
        name: 'how-to-general-videos',
        component: () => import('./views/HowToGeneralVideos.view.vue'),
      },
      {
        path: 'admin-videos',
        name: 'how-to-admin-videos',
        component: () => import('./views/HowToAdminVideos.view.vue'),
      },
    ],
  },
];
